import { color, sizing } from './themeContract.css';

/**
 * Theme for vanilla-extract
 */
export { responsiveStyle } from './responsiveStyle';
export * as shared from './shared.css';

export const vars = { ...sizing, color };
/**
 * Theme for styled-components
 */
export * as ThemeUtils from './themeUtils';
